const crypto = require("crypto");

export function decrypt(encdata, secretKey, isUAA) {
  try {
    secretKey = secretKey.toLowerCase();
    if (isUAA) {
      let repeatStr = secretKey.repeat(4);
      let substracStr = repeatStr.substring(0, 16);
      let userName = substracStr;
      let strUtf8 = unescape(encodeURIComponent(userName));
      let arryBufferData = new Uint8Array(strUtf8.length);
      for (var i = 0; i < strUtf8.length; i++) {
        arryBufferData[i] = strUtf8.charCodeAt(i);
      }
    } else {
      let userId = secretKey + secretKey.substring(0, 6);
      let strUtf8 = unescape(encodeURIComponent(userId));
      let arryBufferData = new Uint8Array(strUtf8.length);
      for (var ii = 0; ii < strUtf8.length; ii++) {
        arryBufferData[ii] = strUtf8.charCodeAt(ii);
      }
    }
    const bData = Buffer.from(encdata, "base64");
    const salt = bData.slice(0, 64);
    const iv = bData.slice(64, 80);
    const tag = bData.slice(80, 96);
    const text = bData.slice(96);
    const key = crypto.pbkdf2Sync(
      secretKey,
      salt,
      cryptoConfig.iterations,
      cryptoConfig.keyLength,
      cryptoConfig.digest
    );
    // AES 256 GCM Mode
    const decipher = crypto.createDecipheriv("aes-256-gcm", key, iv);
    decipher.setAuthTag(tag);
    return decipher.update(text, "binary", "utf8") + decipher.final("utf8");
  } catch (err) {
    return err;
  }
}

export function encrypt(text, secretKey, isUAA) {
  try {
    var iv;
    secretKey = secretKey.toLowerCase();
    if (isUAA) {
      let repeatStr = secretKey.repeat(4);
      let substracStr = repeatStr.substring(0, 16);
      let userName = substracStr;
      let strUtf8 = unescape(encodeURIComponent(userName));
      let arryBufferData = new Uint8Array(strUtf8.length);
      for (var i = 0; i < strUtf8.length; i++) {
        arryBufferData[i] = strUtf8.charCodeAt(i);
      }
      iv = Buffer.from(arryBufferData);
    } else {
      let userId = secretKey + secretKey.substring(0, 6);
      let strUtf8 = unescape(encodeURIComponent(userId));
      let arryBufferData = new Uint8Array(strUtf8.length);
      for (var ii = 0; ii < strUtf8.length; ii++) {
        arryBufferData[ii] = strUtf8.charCodeAt(ii);
      }
      iv = Buffer.from(arryBufferData);
    }
    // random salt
    const salt = crypto.randomBytes(64);
    // derive encryption key
    const key = crypto.pbkdf2Sync(
      secretKey,
      salt,
      cryptoConfig.iterations,
      cryptoConfig.keyLength,
      cryptoConfig.digest
    );
    // AES 256 GCM Mode
    const cipher = crypto.createCipheriv("aes-256-gcm", key, iv);
    // encrypt the given text
    const encrypted = Buffer.concat([
      cipher.update(text, "utf8"),
      cipher.final(),
    ]);
    // extract the auth tag
    const tag = cipher.getAuthTag();
    // generate output

    return Buffer.concat([salt, iv, tag, encrypted]).toString("base64");
  } catch (err) {
    return err;
  }
}

// ======================== //////// ==========================

const cryptoConfig = {
  masterKey: "sfcpnnjFG6dULJfo1BEGqczpfN0SmwZ6bgKO5FcDRfI=",
  iterations: 50,
  keyLength: 32,
  digest: "sha512",
};
